import { Box, Button, Stack } from '@atgfr8/atg-ui-tailwind';
import { Popover, usePopoverRef } from '@components/Popover';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { openModal } from '@store/modals';
import { carrierStore, orderStore, setLoadSureStore } from '@store/orders';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { isAdmin, isManager } from '@utils/utils';
import { CarrierDetailsBlacklist } from '@views/carriers/carrierDetails/components/CarrierDetailsBlacklist';
import {
  ADD_PLAYLIST_ID,
  BOUNCE_CARRIER_MODAL_ID,
} from '@views/order/constants';
import { Show } from 'solid-js';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';

import {
  cancelInsuranceCbModal,
  isLoadSureVendorAttached,
} from './LoadSureHelpers';
import { BounceCarrierModal } from './BounceCarrierModal';
import { hasSavedCarrier, incrementFallout } from './utils';

type PropsT = {
  load: ILoadEditViewModel;
  tabIndex: number;
  disabled?: boolean;
};

export const ProfileFallout = (props: PropsT) => {
  const addPlaylistModalId = `${ADD_PLAYLIST_ID}-${props.tabIndex}`;
  const isBounceEnabled = isFeatureFlagEnabled(
    FeatureFlags.EnableLoadDetailsCarrierBounceTracking,
  );
  const [setBlacklistRef, closeBlacklistPopover] = usePopoverRef();

  return (
    <Stack direction="row">
      <Show
        when={isBounceEnabled()}
        fallback={
          <Box>
            <Button
              dataTestId="carrier-profile-fallout-button"
              onClick={() => {
                if (
                  isLoadSureVendorAttached() &&
                  carrierStore.carrier[props.tabIndex]?.id
                ) {
                  setLoadSureStore('callback', () => () => {
                    void incrementFallout(
                      carrierStore.carrier[props.tabIndex]?.id,
                      props.tabIndex,
                      props.load,
                    );
                  });
                  openModal(cancelInsuranceCbModal);
                } else if (carrierStore.carrier[props.tabIndex]?.id) {
                  void incrementFallout(
                    carrierStore.carrier[props.tabIndex]?.id,
                    props.tabIndex,
                    props.load,
                  );
                }
              }}
              variant="text"
              class="text-armstrong-sm! text-armstrong-blue! px-1! py-1.5!"
              disabled={
                orderStore.isReadOnly ||
                !carrierStore.carrier[props.tabIndex]?.id
              }
            >
              Fallout
            </Button>
          </Box>
        }
      >
        <Show when={hasSavedCarrier(props.load)}>
          <Box>
            <Button
              dataTestId="carrier-profile-bounce-carrier-button"
              onClick={() => openModal(BOUNCE_CARRIER_MODAL_ID)}
              variant="text"
              class="text-armstrong-sm! text-armstrong-blue! px-1! py-1.5!"
              disabled={
                orderStore.isReadOnly ||
                orderStore.isSaving ||
                ['Billed', 'Paid'].includes(props.load.status as string)
              }
            >
              Bounce Carrier
            </Button>
          </Box>
        </Show>
      </Show>
      <Box>
        <Button
          dataTestId="carrier-profile-playlist-button"
          onClick={() => openModal(addPlaylistModalId)}
          variant="text"
          class="text-armstrong-sm!"
          sx={{
            color: '#026EA1',
            padding: '6px 4px',
          }}
        >
          {Boolean(carrierStore.carrier[props.tabIndex]?.id)
            ? 'Add To Playlist'
            : 'Select From Playlist'}
        </Button>
      </Box>
      <Show
        when={
          (isAdmin() || isManager()) &&
          Boolean(carrierStore.carrier[props.tabIndex]?.id)
        }
      >
        <Popover
          ref={setBlacklistRef}
          classes="p-0!"
          eleName={
            <Button
              dataTestId="carrier-profile-blacklist-button"
              variant="text"
              class="text-armstrong-sm!"
              sx={{
                color: '#026EA1',
                padding: '6px 4px',
              }}
            >
              Blacklist
            </Button>
          }
        >
          <CarrierDetailsBlacklist
            closePopover={closeBlacklistPopover}
            carrierId={props.load.carrierId ?? undefined}
            tabIndex={props.tabIndex}
            changeTrackingSource={
              CHANGE_TRACKING_SOURCES.orderDetails.loadDetailsBlacklist
            }
          />
        </Popover>
      </Show>
      <BounceCarrierModal tabIndex={props.tabIndex} />
    </Stack>
  );
};
